import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

function NoteDetail() {
  const { sessionId } = useParams();
  const location = useLocation();
  const note = location.state;

  if (!note) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-2xl font-semibold text-red-600 mb-2">Note not found</h2>
        <p className="text-gray-500">This note may have been deleted or accessed incorrectly.</p>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto p-6 h-screen">
      <div className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200 h-full overflow-y-auto">
        <h1 className="text-2xl font-bold mb-3 text-blue-700">{note.title}</h1>

        <div className="text-sm text-gray-600 mb-2">
          <p><span className="font-semibold text-gray-700">UserName</span> {note.user_name || 'Unknown User'}</p>
          <p><span className="font-semibold text-gray-700">Session ID:</span> {note.session_id}</p>
          <p><span className="font-semibold text-gray-700">Date & Time:</span> {note.timestamp}</p>
        </div>

        <hr className="my-4 border-gray-300" />

        <div className="text-gray-800 whitespace-pre-wrap leading-relaxed">
          {note.content}
        </div>
      </div>
    </div>
  );
}

export default NoteDetail;